import {
  FormControl,
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { personalDetailsFields, groupingFamilyOptions } from "../fieldData";
import { calculateAge } from "../../../../utilis/methods/dateMethods";
import { CustomFormField } from "../../../../utilis/component/CustomFormElement";
import { getLanguage, getMaritalStatus, getRace } from "../../../Patientregistration/v1/registrationServices";
import { useQuery } from "react-query";
import moment from "moment";
import { useParams } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import usePopup from "@hooks/usePopup";
import FileUploadModal from "../../v2/RegistrtionDetails/FileUploadModal";
interface PersonalDetailsProps {
  formControls: UseFormReturn<any>;
}

const StyledTextField = styled("div")(({}) => ({
  "& .MuiTextField-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  // },
}));

const StyledSelect = styled("div")(({}) => ({
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderLeft: 0,
      // "& fieldset": {
      //   borderLeftWidth: 0,
      // },
    },
  },
  // },
}));

const PersonalDetails: React.FC<PersonalDetailsProps> = ({ formControls }) => {
  const { patientid } = useParams();
  const { CustomModal } = usePopup();
  const [idType, setIdType] = useState<string>("Emirates");
  const [ageType, setAgeType] = useState<"D" | "M" | "Y">("Y");
  const [openUpload, setOpenUpload] = useState(false);
  const { control, setValue, watch,clearErrors,getValues } = formControls;

  const {
    data: maritalStatus,
    isLoading: maritalStatusLoading,
  } = useQuery(["getMaritalStatus"],getMaritalStatus,{
    refetchOnWindowFocus: false,
  });

  const {
    data: languages,
    isLoading: languagesLoading,
  } = useQuery(["getLanguage"],getLanguage,{
    refetchOnWindowFocus: false,
  });

  const {
    data: race,
    isLoading: raceLoading,
  } = useQuery(["getRace"],getRace,{
    refetchOnWindowFocus: false,
  });

  const editEmiratesId = (value: string) => {
    const strlen = value?.length;
    const stringCheck = /^[\d-]*$/;
    const dob = getValues(personalDetailsFields.dob.name) 
    if (stringCheck.test(value) && value[strlen - 1] != "-") {
      if (strlen == 1 || strlen == 3 || strlen == 0) {
        if(dob){
           value = `784-${moment(dob).year()}-`
        }else{
          value = `784-`;
        }
      }
      if (strlen == 4) {
        value = value.slice(0, 3) + "-" + value.slice(3);
      }
      if (strlen == 9) {
        const slicedValue = value.slice(0, 8);
        value = slicedValue + "-" + value.slice(8);
      }
      if (strlen == 17) {
        value = value.slice(0, 16) + "-" + value.slice(16);
      }
    } else {
      value = value?.substring(0, strlen - 1) || "";
    }
    strlen < 18
      ? setValue("id", value)
      : setValue("id", value?.substring(0, strlen - 1) || "");
  };

  const onChange = ({
    // type,
    target: { value, name },
  }: {
    type: string;
    target: { value: any; name: string };
  }) => {
    if (name == "id") {
      if (idType == "Emirates") {
        editEmiratesId(value);
      }
    }
  };

  const dobChanges = watch("dob");
  const idTypeChange = watch("idType");

  useEffect(() => {
    setValue("id", "784-");
    setValue(personalDetailsFields.isVip.name,0)
  }, []);

  useEffect(() => {
    if (dobChanges) {
      const { age, ageType } = calculateAge(dobChanges);
      setAgeType(ageType);
      setValue(personalDetailsFields.age.name, age);
      clearErrors(personalDetailsFields.age.name)
      if(idTypeChange == "Emirates"){
        let emiratesId = getValues(personalDetailsFields.id.name) || ""
        if(Boolean(emiratesId?.length != 18)){
          emiratesId =  `784-${moment(dobChanges)?.year() || ""}-`
          setValue(personalDetailsFields.id.name,emiratesId)
        }else{
          emiratesId =  `784-${moment(dobChanges)?.year() || ""}-${emiratesId?.slice(9,emiratesId.length)}`
          setValue(personalDetailsFields.id.name,emiratesId)
        }
      }else{
        (!Boolean(patientid) && setValue(personalDetailsFields.id.name,""));
      }
    }else{
      idTypeChange == "Emirates" ? setValue(personalDetailsFields.id.name,"784-") : setValue(personalDetailsFields.id.name,"")
    }
    setIdType(idTypeChange);
  }, [dobChanges, idTypeChange]);



  return (
    <div>
      <CustomModal open={openUpload} setOpen={setOpenUpload} title="Upload Documents">
        <FileUploadModal
          formControls={formControls}
          onClose={() => setOpenUpload(false)}
        />
      </CustomModal>
      <div className="relative top-4 left-3 bg-blue-600 w-fit px-1 rounded text-white flex items-center gap-1">
        <Typography
          gutterBottom
          component="div"
          fontSize={15}
          color={"inherit"}
          sx={{ mb: 0 }}
        >
          Patient details
        </Typography>
        <Tooltip title="Upload Documents">
          <IconButton
            size="small"
            color="inherit"
            onClick={() => setOpenUpload(true)}
            sx={{ p: 0.5 }}
          >
            <CloudUploadIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </div>
      <Paper elevation={4} className="pt-3 h-full">
        <div className="p-3 grid grid-cols-2 gap-3">
          <CustomFormField
            control={control}
            {...personalDetailsFields.firstName}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.middleName}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.lastName}
          />
          <div className="grid grid-cols-5 gap-2 place-content-center">
            <div className="col-span-3">
              <CustomFormField
                control={control}
                {...personalDetailsFields.dob}
                rules={{ ...personalDetailsFields.dob.rules }}
              />
            </div>
            <div className="col-span-2">
              <CustomFormField
                control={control}
                {...personalDetailsFields.age}
                rules={{...personalDetailsFields.age.rules,maxLength:{value:3,message:"Invalid age"}}}
                fieldProps={{
                  ...personalDetailsFields.age.fieldProps,
                  InputProps: {
                    endAdornment: (
                      <InputAdornment position="start">
                        {ageType}
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </div>
          </div>

          <div className="flex">
            <StyledTextField className="flex w-full">
              <CustomFormField
                control={control}
                {...personalDetailsFields.id}
                fieldProps={{ label: `${idType} ID` }}
                rules={{ ...personalDetailsFields.id.rules, onChange, required:`${idType} ID required`}}
              />
            </StyledTextField>
            <StyledSelect className="flex">
              <Controller
                defaultValue={idType}
                control={control}
                name="idType"
                render={({ field: { onChange, ...field } }) => (
                  <FormControl sx={{ width: 35 }} size="small">
                    <Select
                      {...field}
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={""}
                      onChange={(e) => {
                        onChange(e.target.value);
                        setIdType(e.target.value);
                        setValue("id", "");
                      }}
                    >
                      <MenuItem selected value={"Emirates"}>
                        Emirates
                      </MenuItem>
                      <MenuItem value={"Passport"}>Passport</MenuItem>
                      <MenuItem value={"GCC"}>GCC</MenuItem>
                    </Select>
                  </FormControl>
                )}
              />
            </StyledSelect>
          </div>

          <CustomFormField
            control={control}
            {...personalDetailsFields.maritalStatus}
            options={maritalStatus?.response || []}
            autocompleteProps={{
              ...personalDetailsFields.maritalStatus.autocompleteProps,
              loading: maritalStatusLoading,
            }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.gender}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.isVip}
            radioProps={{ ...personalDetailsFields.isVip.radioProps }}
            fieldProps={{ ...personalDetailsFields.isVip.fieldProps }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.language}
            options={languages?.response || []}
            loading={languagesLoading}
            fieldProps={{
              ...personalDetailsFields.language.fieldProps,
            }}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.groupingFamily}
            options={groupingFamilyOptions}
          />
          <CustomFormField
            control={control}
            {...personalDetailsFields.race}
            options={race?.response || []}
            loading={raceLoading}
            fieldProps={{
              ...personalDetailsFields.race.fieldProps,
            }}
          />
          
        </div>
      </Paper>
    </div>
  );
};

export default PersonalDetails;
